<app-confirmation-modal toasterText="Manager removed" [request$]="request$" buttonText="Remove" modalHeading="Are you sure you want to remove this direct manager?">
    <p>{{text}}</p>
</app-confirmation-modal>